import { ReactComponent as ForwardStepOutlinedIcon } from 'assets/icons/forward-step-outlined.svg';

export default ForwardStepOutlinedIcon;
